// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import ProgramCount from "hooks/ProgramCount";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class InstrumentsList extends Component {
  static propTypes = {
    // classes: PropTypes.object,
    instruments: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedInstrument, index) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedInstrument, index);
    }
  }

  render() {
    const { instruments } = this.props;

    return (
      <Table
        data={instruments}
        meta={[
          {
            path: "name",
            title: "Name",
          },
          {
            path: "programCount",
            title: "Programs#",
            render: (t, d) => (
              <ProgramCount
                value={t}
                id={d.id}
                title={`${d.name} related programs`}
                type="instruments"
              />
            ),
          },
        ]}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(InstrumentsList);
